const DEFAULT_LOCALE = 'nl';
const DISCOVER_IFRAME_URL = 'https://s.pointerpro.com/sispe';
const TIPS_IFRAME_URL = 'https://ikmotiveer.wixsite.com/mijnsite';
const SURVEY_URL = 'https://s.pointerpro.com/';

const getDiscoverIframeUrl = user =>
  `${DISCOVER_IFRAME_URL}?cf1=${user.id}&cf2=${user.email}&cf3=${user.firstname
  }&cf4=${user.lastname}`;

const getDiscoverResultIframeUrl = user =>
  `${DISCOVER_IFRAME_URL}?cf1=${user.id}&cf2=${user.email}&cf3=${user.firstname
  }&cf4=${user.lastname}`;

const CLOUD_FUNCTION_PDF_READER_URL =
  process.env.REACT_APP_CLOUD_FUNCTION_PDF_READER_URL || '';
const getSurveyUrlPDF = (buildingBlockId, sapId) => {
  return CLOUD_FUNCTION_PDF_READER_URL.replace(
    '{url}',
    `https://api.pointerpro.com/v2/surveys/${buildingBlockId}/reports/sessions/${sapId}`
  );
};

const API_URL = process.env.REACT_APP_API_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';
const API_RESET_PASSWORD_URL =
  API_URL + process.env.REACT_APP_API_RESET_PASSWORD_PATH || '';
const API_SIGNUP_URL = API_URL + process.env.REACT_APP_API_SIGNUP_PATH || '';

const ANALYSE_SURVEY_LAST_URL = 'http://localhost:3000/iframe-last.html';
const ANALYSE_BUILDING_BLOCKS = [
  {
    id: 1,
    title: 'Structuur',
    data: [
      {
        id: 1,
        title: 'Begeleidend',
        items: [
          {
            id: 1,
            label: 'Motiverende feedback',
            url: 'vbbfkooc'
          },
          {
            id: 2,
            label: 'Zelfinzicht stimuleren',
            url: 'nwgsyeqa'
          }
        ]
      },
      {
        id: 2,
        title: 'Verduidelijkend',
        items: [
          {
            id: 3,
            label: 'Duidelijkheid creëren',
            url: 'jfyvtoet'
          },
          {
            id: 4,
            label: 'Consequent opvolgen',
            url: 'ykqzfkai'
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Autonomie ondersteuning',
    data: [
      {
        id: 1,
        title: 'Afstemmend',
        items: [
          {
            id: 5,
            label: 'Spelplezier voeden',
            url: 'ercjqbld'
          },
          {
            id: 6,
            label: 'Betekenisvolle uitleg geven',
            url: 'pbtkxask'
          },
          {
            id: 7,
            label: 'Uitnodigend communiceren',
            url: 'uewtwxwu'
          }
        ]
      },
      {
        id: 2,
        title: 'Particitief',
        items: [
          {
            id: 8,
            label: 'Inbreng stimuleren',
            url: 'lamyvbcw'
          },
          {
            id: 9,
            label: 'Aanbieden van keuze',
            url: 'hdqzuzvt'
          }
        ]
      }
    ]
  }
];

const ANALYSE_TIME_RANGE = 3600 * 24; // 300s

module.exports = {
  DEFAULT_LOCALE,
  DISCOVER_IFRAME_URL,
  TIPS_IFRAME_URL,
  ANALYSE_SURVEY_LAST_URL,
  ANALYSE_BUILDING_BLOCKS,
  ANALYSE_TIME_RANGE,
  SURVEY_URL,
  getDiscoverIframeUrl,
  getSurveyUrlPDF,
  getDiscoverResultIframeUrl,
  API_RESET_PASSWORD_URL,
  API_SIGNUP_URL,
  API_URL,
  API_KEY
};



// WEBPACK FOOTER //
// ./src/constants.js